var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"newsTop"},[_c('h3',[_vm._v(_vm._s(_vm.title))])]),_c('div',{staticClass:"line"})])}
var staticRenderFns = []

export { render, staticRenderFns }